import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";

export const geofenceTimeByRtuId = async (id, type) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/geofence-time/${id}/${type}`,
        );
        // Ensure we always return an array
        return Array.isArray(response.data) ? response.data : [];
    } catch (e) {
        console.error(e);
        return []; // Return empty array on error
    }
};